module.exports = __webpack_public_path__ + "img/letter_complete.de6b5eeb.png";